import { baseApi } from "./baseApi"
import type { BonusAnalytics } from "../../types/bonuses"

export interface LeaderboardRow {
  id: string
  username: string
  balance: number
}

export interface DashboardSnapshot {
  metrics: Record<string, number>
  generatedAt: string
}

export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getLeaderboard: build.query<LeaderboardRow[], void>({
      query: () => ({ url: "/leaderboard", adminApi: "v1" }),
      providesTags: [{ type: "Dashboard", id: "LEADERBOARD" }],
    }),
    getDashboardSnapshot: build.query<DashboardSnapshot, void>({
      query: () => ({ url: "/dashboard", adminApi: "v1" }),
      providesTags: [{ type: "Dashboard", id: "SNAPSHOT" }],
    }),
    getBonusAnalytics: build.query<BonusAnalytics, void>({
      query: () => ({ url: "/bonuses/analytics", adminApi: "v1" }),
      providesTags: [{ type: "Dashboard", id: "BONUS_ANALYTICS" }],
    }),
  }),
})

export const {
  useGetLeaderboardQuery,
  useGetDashboardSnapshotQuery,
  useGetBonusAnalyticsQuery,
} = dashboardApi
